import React from 'react'
import { Card, Input, Space, Button, Tabs } from 'antd'
import { SearchOutlined, BellOutlined } from '@ant-design/icons'
import { useNotifications } from '../hooks/useNotifications'
import { useNotificationActions } from '../hooks/useNotificationActions'
import { NotificationsTable } from '../components/NotificationsTable'
import { NotificationDetailsDrawer } from '../components/NotificationDetailsDrawer'
import { SendNotificationModal } from '../components/SendNotificationModal'

export const NotificationsScreen: React.FC = () => {
    const {
        notifications,
        searchText, setSearchText,
        activeTab, setActiveTab
    } = useNotifications()

    const {
        selectedNotification,
        isDetailDrawerOpen,
        isSendModalOpen,
        handleViewDetails,
        openSendModal,
        closeSendModal,
        handleSendNotification,
        handleRetryNotification,
        closeDrawer
    } = useNotificationActions()

    const tabItems = [
        { key: 'all', label: 'All Notifications', children: null },
        { key: 'pending', label: 'Pending', children: null },
        { key: 'sent', label: 'Sent', children: null },
        { key: 'failed', label: 'Failed', children: null },
    ]

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search notifications..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Button type="primary" icon={<BellOutlined />} onClick={openSendModal}>
                        Send Notification
                    </Button>
                </Space>

                <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />

                <NotificationsTable
                    notifications={notifications}
                    onRowClick={handleViewDetails}
                    onRetry={handleRetryNotification}
                />
            </Card>

            <NotificationDetailsDrawer
                notification={selectedNotification}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onRetry={handleRetryNotification}
            />

            <SendNotificationModal
                open={isSendModalOpen}
                onCancel={closeSendModal}
                onSend={handleSendNotification}
            />
        </Space>
    )
}
